/* ==========================================================================
   WOOL & OAK — PDP JavaScript  v2.1 — 2026-04-01
   Scoped to pages with .wo-pdp-active on body
   ========================================================================== */

(function () {
  if (!document.body.classList.contains('wo-pdp-active')) return;

  /* ── Editorial heading split: last word (or text after a "|") becomes italic ── */
  function splitEditorialHeading(text) {
    if (!text) return '';
    var pipe = text.indexOf('|');
    if (pipe >= 0) {
      var first = text.substring(0, pipe).trim();
      var rest  = text.substring(pipe + 1).trim();
      return (first ? first + ' ' : '') + '<em>' + rest + '</em>';
    }
    var words = text.trim().split(/\s+/);
    if (words.length <= 1) return text;
    return words.slice(0, -1).join(' ') + ' <em>' + words[words.length - 1] + '</em>';
  }

  /* ── Airline Modal — search filter ─────────────────────────────────────── */
  function initAirlineSearch() {
    var search = document.querySelector('.wo-airline-search');
    if (!search) return;
    search.addEventListener('input', function () {
      var q = this.value.toLowerCase();
      var rows = document.querySelectorAll('.wo-airline-table tbody tr');
      rows.forEach(function (row) {
        row.style.display = row.cells[0].textContent.toLowerCase().includes(q) ? '' : 'none';
      });
    });
  }

  /* ── Tab System — transforms accordion-group into horizontal tabs ────── */
  function initTabs() {
    var group = document.querySelector('.wo-pdp-active .accordion-group');
    if (!group || group.querySelector('.wo-tab-bar')) return;
    var items = Array.from(group.querySelectorAll(':scope > .product-info__block-item[data-block-type="accordion"]'));
    var visible = items.filter(function (item) {
      var d = item.querySelector('details.accordion');
      if (!d) return false;
      if (d.classList.contains('Pre-Ord')) return false;
      if (getComputedStyle(item).display === 'none') return false;
      return true;
    });
    if (visible.length < 2) return;

    var bar = document.createElement('div');
    bar.className = 'wo-tab-bar';
    visible.forEach(function (item, i) {
      var t = item.querySelector('.accordion__toggle span');
      var btn = document.createElement('button');
      btn.className = 'wo-tab-btn' + (i === 0 ? ' active' : '');
      btn.textContent = t ? t.textContent.trim() : 'Tab ' + (i + 1);
      btn.setAttribute('data-tab-idx', i);
      bar.appendChild(btn);
    });
    group.insertBefore(bar, group.firstChild);

    visible.forEach(function (item) {
      var d = item.querySelector('details.accordion');
      if (d) d.setAttribute('open', '');
    });

    /* Wrap tab panels in a grid container — all panels stack in same cell,
       tallest one defines height, hidden ones use visibility not display */
    var contentWrap = document.createElement('div');
    contentWrap.className = 'wo-tab-content-wrap';
    visible.forEach(function (item) { contentWrap.appendChild(item); });
    group.appendChild(contentWrap);
    visible.forEach(function (item, i) { if (i > 0) item.classList.add('wo-tab-hidden'); });

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.wo-tab-btn');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-tab-idx'), 10);
      bar.querySelectorAll('.wo-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var barRect = bar.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      bar.scrollTo({ left: bar.scrollLeft + btnRect.left - barRect.left - (barRect.width - btnRect.width) / 2, behavior: 'smooth' });
      visible.forEach(function (item, i) { item.classList.toggle('wo-tab-hidden', i !== idx); });
    });
  }

  /* ── Bundle Cards — wrap in horizontal scroll row + arrows ───────────── */
  function wrapBundleCards() {
    var container = document.querySelector('.wo-pdp-active .wo-bundle-offers');
    if (!container || container.querySelector('.wo-bundle-cards-row')) return;
    var cards = container.querySelectorAll('.wo-bundle-card');
    if (cards.length < 2) return;
    var row = document.createElement('div');
    row.className = 'wo-bundle-cards-row';
    cards.forEach(function (c) { row.appendChild(c); });
    container.appendChild(row);
  }

  /* ── Bundle Variant Sync — material filter + color sync ────────────────── */
  function initBundleVariantSync() {
    var fmt = window.Shopify && window.Shopify.money_format || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var o = '{{', c = '}}';
      return fmt
        .replace(o + 'amount_with_comma_separator' + c, amount.replace('.', ','))
        .replace(o + 'amount_no_decimals_with_comma_separator' + c, amountNoDecimals)
        .replace(o + 'amount_no_decimals' + c, amountNoDecimals)
        .replace(o + 'amount' + c, amount);
    }

    function getCardData(card) {
      var el = card.querySelector('.wo-bundle-data');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function getMaterial(option1) {
      var h = option1.toLowerCase();
      if (h.indexOf('herringbone') !== -1) return 'herringbone';
      if (h.indexOf('nylon') !== -1) return 'nylon';
      return 'leather';
    }

    function updateItemByColor(card, itemIdx, color) {
      var data = getCardData(card);
      if (!data || !data.items || !data.items[itemIdx]) return;
      var item = data.items[itemIdx];
      var matched = null;
      for (var j = 0; j < item.variants.length; j++) {
        if (item.variants[j].option1 === color) { matched = item.variants[j]; break; }
      }
      if (!matched) return;
      /* UX: crossfade image on swatch change */
      var imgEl = card.querySelector('[data-bundle-item-img="' + itemIdx + '"]');
      if (imgEl && matched.image) {
        imgEl.classList.add('wo-img-swapping');
        setTimeout(function () {
          imgEl.src = matched.image;
          imgEl.onload = function () { imgEl.classList.remove('wo-img-swapping'); };
          /* Fallback if onload doesn't fire (cached image) */
          setTimeout(function () { imgEl.classList.remove('wo-img-swapping'); }, 250);
        }, 150);
      }
      /* UX: crossfade price on change */
      var row = card.querySelector('[data-bundle-item="' + itemIdx + '"]');
      if (row) {
        var priceEl = row.querySelector('[data-bundle-item-price]');
        if (priceEl) {
          priceEl.classList.add('wo-price-updating');
          setTimeout(function () {
            priceEl.innerHTML = formatMoney(matched.price);
            priceEl.classList.remove('wo-price-updating');
          }, 150);
        }
      }
      /* Update color label */
      var label = card.querySelector('[data-bundle-color-label="' + itemIdx + '"]');
      if (label) label.textContent = color;
    }

    /* PDP variant change → sync matching color in bundle cards */
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.option1) return;
      var color = variant.option1;
      var cards = document.querySelectorAll('.wo-pdp-active [data-bundle-card]');
      cards.forEach(function (card) {
        var data = getCardData(card);
        if (!data || !data.items) return;
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].product_id !== data.main_product_id) continue;
          var hasColor = false;
          for (var j = 0; j < data.items[i].variants.length; j++) {
            if (data.items[i].variants[j].option1 === color) { hasColor = true; break; }
          }
          if (hasColor) {
            updateItemByColor(card, i, color);
            var row = card.querySelector('[data-bundle-item="' + i + '"]');
            if (row) {
              var radio = row.querySelector('.wo-item-radio[data-option1="' + color + '"]');
              if (radio) radio.checked = true;
            }
          }
        }
      });
    });

    /* Low stock urgency — shows per-variant count below variant picker, updates on variant change */
    (function () {
      var dataEl = document.querySelector('[data-variant-inventory]');
      if (!dataEl) return;
      var inv;
      try { inv = JSON.parse(dataEl.textContent); } catch (err) { return; }

      /* Create a single stock badge element below the variant picker */
      var picker = document.querySelector('.wo-pdp-active variant-picker');
      if (!picker) return;
      var badge = document.createElement('p');
      badge.className = 'wo-variant-stock-msg';
      picker.parentElement.insertBefore(badge, picker.nextSibling);

      function updateStockBadge() {
        /* Find currently selected variant ID from the product form */
        var form = document.querySelector('.wo-pdp-active form[action*="/cart/add"]');
        var variantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
        var vid = variantInput ? variantInput.value : null;
        if (!vid || !inv[vid]) { badge.style.display = 'none'; return; }
        var info = inv[vid];
        if (info.managed !== 'shopify' || info.policy !== 'deny' || info.qty <= 0 || info.qty > 10) {
          badge.style.display = 'none'; return;
        }
        badge.textContent = info.option1 + ' \u2014 Only ' + info.qty + ' left';
        badge.style.display = '';
      }

      /* Initial check (delay to let theme set variant ID) */
      setTimeout(updateStockBadge, 500);

      /* Listen for variant changes — theme dispatches 'variant:change' (not 'changed') */
      document.addEventListener('variant:change', function (e) {
        /* The event detail contains the variant directly */
        if (e.detail && e.detail.variant) {
          var vid = String(e.detail.variant.id);
          if (inv[vid]) {
            var info = inv[vid];
            if (info.managed === 'shopify' && info.policy === 'deny' && info.qty > 0 && info.qty <= 10) {
              badge.textContent = info.option1 + ' \u2014 Only ' + info.qty + ' left';
              badge.style.display = '';
              return;
            }
          }
          badge.style.display = 'none';
        }
      });
      /* Fallback: also listen for input changes */
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-picker') || e.target.name === 'id') setTimeout(updateStockBadge, 100);
      });
    })();

    /* Bundle swatch change → update that item's image/price/label */
    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('wo-item-radio')) return;
      var card = e.target.closest('[data-bundle-card]');
      var row = e.target.closest('[data-bundle-item]');
      if (!card || !row) return;
      var idx = parseInt(row.getAttribute('data-bundle-item'), 10);
      var color = e.target.getAttribute('data-option1');
      if (!isNaN(idx) && color) updateItemByColor(card, idx, color);
    });

    /* Material button click → update label + benefit text */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nybut');
      if (!btn) return;
      var material = 'leather';
      if (btn.classList.contains('Nylona')) material = 'nylon';
      if (btn.classList.contains('canvas')) material = 'herringbone';

      /* Update "Material: Full-Grain" label */
      var matLabel = document.querySelector('.mat-selected');
      if (matLabel) {
        var labels = { leather: 'Full-Grain', nylon: 'High Ballistic Nylon', herringbone: 'Stain-Proof Herringbone' };
        matLabel.textContent = labels[material] || '';
      }

      /* Update benefit text below buttons */
      var benefit = document.querySelector('.wo-mat-benefit');
      if (benefit) {
        var benefitKey = material === 'herringbone' ? 'canvas' : material;
        if (benefit.dataset[benefitKey]) benefit.textContent = benefit.dataset[benefitKey];
      }
    });
  }

  /* ── Scroll Arrows — generic for bundle + complementary ──────────────── */
  function injectArrows(headingEl, scrollEl) {
    if (headingEl.querySelector('.wo-scroll-arrows')) return;
    var arrows = document.createElement('div');
    arrows.className = 'wo-scroll-arrows';
    var left = document.createElement('button');
    left.className = 'wo-scroll-arrow';
    left.innerHTML = '\u2039';
    var right = document.createElement('button');
    right.className = 'wo-scroll-arrow';
    right.innerHTML = '\u203A';
    left.addEventListener('click', function () { scrollEl.scrollBy({ left: -200, behavior: 'smooth' }); });
    right.addEventListener('click', function () { scrollEl.scrollBy({ left: 200, behavior: 'smooth' }); });
    arrows.appendChild(left);
    arrows.appendChild(right);
    headingEl.style.display = 'flex';
    headingEl.style.justifyContent = 'space-between';
    headingEl.style.alignItems = 'center';
    headingEl.appendChild(arrows);
  }

  /* ── Sticky CTA — appears when buy buttons scroll out of view ────────── */
  function initStickyCTA() {
    if (document.querySelector('.wo-sticky-cta')) return;
    var buyBtns = document.querySelector('.wo-pdp-active .product-info buy-buttons');
    if (!buyBtns) return;

    var bar = document.createElement('div');
    bar.className = 'wo-sticky-cta wo-sticky-hidden';
    var wrap = document.createElement('div');
    wrap.className = 'wo-sticky-btns';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wo-sticky-atc';
    var priceEl = document.querySelector('.wo-pdp-active .product-info sale-price .money');
    var price = priceEl ? priceEl.textContent.trim() : '';
    btn.textContent = 'ADD TO CART' + (price ? ' \u2014 ' + price : '');
    btn.addEventListener('click', function () {
      var orig = document.querySelector('.wo-pdp-active .product-info buy-buttons button[type="submit"]');
      if (orig) orig.click();
    });
    wrap.appendChild(btn);
    bar.appendChild(wrap);
    document.body.appendChild(bar);

    /* Show sticky bar whenever the main ATC button is out of view — BOTH before the
       shopper reaches it and after they scroll past it. 75% of mobile visitors never
       scroll to the buy button, so the bar must be available from the first viewport. */
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          bar.classList.add('wo-sticky-hidden');
        } else {
          bar.classList.remove('wo-sticky-hidden');
        }
      });
    }, { threshold: 0 }).observe(buyBtns);
  }

  /* ── "Why the ___" — Mobile Carousel + Desktop Tabbed Section ── */
  function buildWhyCarousel() {
    var existing = document.querySelector('.wo-why-carousel');
    var wantDesktop = window.innerWidth >= 1200;
    var existingIsDesktop = existing && existing.classList.contains('wo-why-desktop-sticky');
    /* If a carousel already exists AND it's the right type for the current
       viewport, keep it. Otherwise rip it out and rebuild for the new size. */
    if (existing) {
      if (wantDesktop === existingIsDesktop) return;
      existing.parentNode && existing.parentNode.removeChild(existing);
      document.body.classList.remove('wo-why-carousel-ready');
      // Restore the original multi-media-with-text sections so we can re-read them
      document.querySelectorAll('.wo-pdp-active .shopify-section--multiple-media-with-text, .wo-pdp-active .shopify-section--rich-text[id*="rich_text_reasons"]').forEach(function (s) {
        s.style.display = '';
      });
    }
    var sections = document.querySelectorAll('.wo-pdp-active .shopify-section--multiple-media-with-text');
    if (!sections.length) return;
    var isDesktop = wantDesktop;

    /* ── Build HTML ── */
    if (isDesktop) {
      /* ── DESKTOP: reads content directly from Multiple Media sections in the DOM ── */
      /* Extract video, title, body from each section */
      var desktopCards = [];
      sections.forEach(function (s) {
        var source = s.querySelector('video source');
        var videoUrl = source ? source.src : '';
        /* Title: .number-heading or .h3 — read innerHTML so the title/title2 span is preserved (editorial 700 + italic 400) */
        var titleEl = s.querySelector('.number-heading') || s.querySelector('.h3');
        var title = titleEl ? titleEl.innerHTML.trim() : '';
        /* Body: the prose content after the title */
        var contentWrap = s.querySelector('.multiple-media-with-text__content-wrapper .prose, .multiple-media-with-text__content-wrapper .v-stack');
        var bodyEl = contentWrap ? contentWrap.querySelector('div:not(.h6):not(.number-heading):not(.button-group)') : null;
        var body = '';
        if (bodyEl) {
          body = bodyEl.innerHTML.trim();
        } else {
          /* Fallback: grab all <p> inside content wrapper */
          var contentArea = s.querySelector('.multiple-media-with-text__content-wrapper');
          if (contentArea) {
            var paras = contentArea.querySelectorAll('p:not(.h6):not(.number-heading)');
            var bodyParts = [];
            paras.forEach(function (p) { if (p.textContent.trim()) bodyParts.push(p.outerHTML); });
            body = bodyParts.join('');
          }
        }
        desktopCards.push({ videoUrl: videoUrl, title: title, body: body });
      });

      if (!desktopCards.length) return;

      /* ── Exact 5 Reasons LP sticky scroll layout ── */
      var wrapper = document.createElement('div');
      wrapper.className = 'wo-why-carousel wo-why-desktop-sticky wo-lp';

      var reasonsDesktop = document.createElement('div');
      reasonsDesktop.className = 'wo-lp__reasons-desktop';

      /* Left: sticky media column */
      var mediaCol = document.createElement('div');
      mediaCol.className = 'wo-lp__rd-media-col';
      var stickyWrap = document.createElement('div');
      stickyWrap.className = 'wo-lp__rd-sticky';

      desktopCards.forEach(function (c, i) {
        var imgWrap = document.createElement('div');
        imgWrap.className = 'wo-lp__rd-img-wrap' + (i === 0 ? ' active' : '');
        imgWrap.setAttribute('data-reason-img', i);
        if (c.videoUrl) {
          imgWrap.innerHTML = '<video autoplay muted loop playsinline preload="metadata"><source src="' + c.videoUrl + '" type="video/mp4"></video>';
        }
        stickyWrap.appendChild(imgWrap);
      });

      /* Progress dots */
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'wo-lp__rd-progress';
      desktopCards.forEach(function (c, i) {
        var dot = document.createElement('div');
        dot.className = 'wo-lp__rd-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('data-reason-dot', i);
        dotsWrap.appendChild(dot);
      });
      stickyWrap.appendChild(dotsWrap);
      mediaCol.appendChild(stickyWrap);
      reasonsDesktop.appendChild(mediaCol);

      /* Right: scrolling text column */
      var textCol = document.createElement('div');
      textCol.className = 'wo-lp__rd-text-col';
      desktopCards.forEach(function (c, i) {
        var num = '0' + (i + 1);
        var card = document.createElement('div');
        card.className = 'wo-lp__rd-card';
        card.setAttribute('data-reason-card', i);
        card.innerHTML =
          '<div class="wo-lp__rd-num rv">' + num + '</div>' +
          '<div class="wo-lp__rd-bar rv rv-d1"></div>' +
          '<h2 class="wo-lp__rd-heading rv rv-d2">' + c.title + '</h2>' +
          '<div class="wo-lp__rd-text rv rv-d3">' + c.body + '</div>' +
          '<a href="#wo-buy-box" class="wo-lp__rd-cta rv rv-d4">GET YOURS</a>';
        textCol.appendChild(card);
      });
      reasonsDesktop.appendChild(textCol);

      /* Section heading above the whole layout — editorial split (last word italic) */
      var cfg = window.__woWhyCards || {};
      if (cfg.heading) {
        var sectionHeading = document.createElement('h2');
        sectionHeading.className = 'wo-lp__section-heading';
        sectionHeading.innerHTML = splitEditorialHeading(cfg.heading);
        wrapper.appendChild(sectionHeading);
      }

      wrapper.appendChild(reasonsDesktop);

      /* Insert and hide originals */
      var reasonsHeader = document.querySelector('.wo-pdp-active .shopify-section--rich-text[id*="rich_text_reasons"]');
      var anchor = reasonsHeader
        || document.querySelector('.wo-pdp-active [id*="before_after"]')
        || document.querySelector('.wo-pdp-active [id*="1728056287229ffa50"]')
        || sections[0];
      if (anchor) {
        anchor.parentNode.insertBefore(wrapper, reasonsHeader || anchor);
        document.body.classList.add('wo-why-carousel-ready');
        if (reasonsHeader) reasonsHeader.style.display = 'none';
        sections.forEach(function (s) { s.style.display = 'none'; });
      }

      /* IntersectionObserver: swap media on scroll — same as 5 Reasons LP */
      var textCards = textCol.querySelectorAll('.wo-lp__rd-card');
      var mediaWraps = stickyWrap.querySelectorAll('.wo-lp__rd-img-wrap');
      var mediaDots = stickyWrap.querySelectorAll('.wo-lp__rd-dot');
      var activeIdx = 0;

      function setActiveMedia(idx) {
        if (idx === activeIdx) return;
        mediaWraps.forEach(function (m) { m.classList.remove('active'); });
        mediaDots.forEach(function (d) { d.classList.remove('active'); });
        if (mediaWraps[idx]) mediaWraps[idx].classList.add('active');
        if (mediaDots[idx]) mediaDots[idx].classList.add('active');
        mediaWraps.forEach(function (m, i) {
          var vid = m.querySelector('video');
          if (!vid) return;
          if (i === idx) vid.play();
          else vid.pause();
        });
        activeIdx = idx;
      }

      var cardIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = parseInt(e.target.getAttribute('data-reason-card'), 10);
            setActiveMedia(idx);
          }
        });
      }, { threshold: 0.45 });

      textCards.forEach(function (card) { cardIO.observe(card); });

      /* Pause non-active videos on init */
      mediaWraps.forEach(function (m, i) {
        if (i > 0) {
          var vid = m.querySelector('video');
          if (vid) vid.pause();
        }
      });

      /* Reveal animation — exact LP IntersectionObserver */
      var rvEls = wrapper.querySelectorAll('.rv');
      var rvIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('v');
            rvIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      rvEls.forEach(function (el) { rvIO.observe(el); });

    } else {
      /* ── MOBILE: Horizontal scroll carousel with blur/dim ── */
      /* Mobile uses __woWhyCards config (separate from desktop) */
      var cfg = window.__woWhyCards;
      if (!cfg || !cfg.heading || !cfg.cards || !cfg.cards[0].title) return;
      var videoUrls = [];
      sections.forEach(function (s) {
        var source = s.querySelector('video source');
        var src = source && source.src ? source.src : (source ? source.getAttribute('src') : '');
        if (!src && source) src = source.getAttribute('data-src') || '';
        if (!src) {
          var nestedVid = s.querySelector('video');
          src = nestedVid ? (nestedVid.src || nestedVid.getAttribute('src') || nestedVid.getAttribute('data-src') || '') : '';
        }
        videoUrls.push(src || '');
      });

      var carousel = document.createElement('div');
      carousel.className = 'wo-why-carousel';
      carousel.innerHTML = '<p class="wo-why-heading">' + splitEditorialHeading(cfg.heading) + '</p>';

      var strip = document.createElement('div');
      strip.className = 'wo-why-cards';

      cfg.cards.forEach(function (c, i) {
        var num = (i + 1) < 10 ? '0' + (i + 1) : '' + (i + 1);
        var card = document.createElement('div');
        card.className = 'wo-why-card';
        card.setAttribute('data-card-index', i);
        var vid = '';
        var videoUrl = videoUrls[i] || '';
        if (videoUrl) {
          vid = '<video autoplay muted loop playsinline preload="metadata" class="wo-why-card__video"><source src="' +
            videoUrl + '" type="video/mp4"></video>';
        }
        card.innerHTML = vid +
          '<div class="wo-why-card__content">' +
          '<span class="wo-why-card__badge">' + num + '</span>' +
          '<p class="wo-why-card__title">' + c.title + '</p>' +
          '<p class="wo-why-card__text">' + c.text + '</p>' +
          '<a href="#wo-buy-box" class="wo-why-card__cta">GET YOURS</a></div>';
        strip.appendChild(card);
      });
      carousel.appendChild(strip);

      /* Page dots — same visual language as the W&O Difference section */
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'wo-why-dots';
      cfg.cards.forEach(function (c, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wo-why-dot';
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('data-dot-index', i);
        dotsWrap.appendChild(dot);
      });
      carousel.appendChild(dotsWrap);

      /* Insert and hide originals */
      var reasonsHeader = document.querySelector('.wo-pdp-active .shopify-section--rich-text[id*="rich_text_reasons"]');
      var anchor = reasonsHeader
        || document.querySelector('.wo-pdp-active [id*="before_after"]')
        || document.querySelector('.wo-pdp-active [id*="1728056287229ffa50"]')
        || sections[0];
      if (anchor) {
        anchor.parentNode.insertBefore(carousel, reasonsHeader || anchor);
        document.body.classList.add('wo-why-carousel-ready');
        if (reasonsHeader) reasonsHeader.style.display = 'none';
        sections.forEach(function (s) { s.style.display = 'none'; });
      } else {
        var mainSec = document.querySelector('.wo-pdp-active .shopify-section--main-product');
        if (mainSec && mainSec.parentNode) {
          mainSec.parentNode.insertBefore(carousel, mainSec.nextSibling);
          document.body.classList.add('wo-why-carousel-ready');
          if (reasonsHeader) reasonsHeader.style.display = 'none';
          sections.forEach(function (s) { s.style.display = 'none'; });
        }
      }

      /* Mobile: scroll-snap + blur/dim + dot sync */
      var cards = strip.querySelectorAll('.wo-why-card');
      var dots = dotsWrap.querySelectorAll('.wo-why-dot');
      var mobileIndex = 0;
      function updateMobile() {
        var cardW = cards[0].offsetWidth + 10;
        var idx = Math.round(strip.scrollLeft / cardW);
        if (idx < 0) idx = 0;
        if (idx >= cards.length) idx = cards.length - 1;
        if (idx === mobileIndex) return;
        mobileIndex = idx;
        cards.forEach(function (c, i) {
          var vid = c.querySelector('video');
          if (i === idx) {
            c.classList.remove('inactive');
            if (vid) vid.play();
          } else {
            c.classList.add('inactive');
            if (vid) vid.pause();
          }
        });
        dots.forEach(function (d, i) {
          d.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }
      cards.forEach(function (c, i) {
        if (i > 0) {
          c.classList.add('inactive');
          var v = c.querySelector('video');
          if (v) v.pause();
        }
      });
      var scrollTimer;
      strip.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateMobile, 80);
      });
      /* Click dot to scroll to that card */
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var idx = parseInt(d.getAttribute('data-dot-index'), 10);
          var cardW = cards[0].offsetWidth + 10;
          strip.scrollTo({ left: idx * cardW, behavior: 'smooth' });
        });
      });
    }
  }

  /* ── Thumbnail scroll — arrow visibility + wheel capture ─────────── */
  function initThumbGallery() {
    var scroller = document.querySelector('.wo-pdp-active .product-gallery__thumbnail-scroller');
    var list = scroller && scroller.closest('.product-gallery__thumbnail-list');
    if (!scroller || !list) return;

    function check() {
      var atEnd = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 8;
      var noOverflow = scroller.scrollHeight <= scroller.clientHeight + 2;
      list.classList.toggle('wo-thumbs-scrolled-end', atEnd || noOverflow);
    }

    scroller.addEventListener('scroll', check);
    check();
    window.addEventListener('load', check);

    /* Capture wheel events over thumbnails so they scroll independently */
    list.addEventListener('wheel', function (e) {
      var canScroll = scroller.scrollHeight > scroller.clientHeight + 2;
      if (!canScroll) return;
      var atTop = scroller.scrollTop <= 0 && e.deltaY < 0;
      var atBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 1 && e.deltaY > 0;
      if (!atTop && !atBottom) {
        e.preventDefault();
        scroller.scrollTop += e.deltaY;
      }
    }, { passive: false });
  }

  /* ── Move Okendo stars into tagline row ───────────────────────────────── */
  /* Desktop only. Targets the app-block .oke-sr (NOT the .mobileone .mob-flex
     stars — those belong to the mobile/iPad header and must stay put). */
  var _starsObserverAttached = false;
  function moveStarsToTagline() {
    if (window.innerWidth < 1200) return; /* below desktop: mob-flex owns stars */
    var taglineRow = document.querySelector('.wo-pdp-active .wo-tagline-row');
    if (!taglineRow) return;
    var placeholder = taglineRow.querySelector('div:first-child');
    if (!placeholder) return;
    var appBlock = document.querySelector('.wo-pdp-active .product-info__block-item[data-block-type="@app"]');
    if (!appBlock) return;

    function tryMove() {
      /* Already in tagline row? Done. */
      if (taglineRow.querySelector('.oke-sr')) return true;
      /* Scope the query to the app block so we never grab .mobileone stars */
      var okeSr = appBlock.querySelector('.oke-sr');
      if (!okeSr) return false;
      placeholder.appendChild(okeSr);
      /* Hide app block so Okendo re-renders stay invisible */
      appBlock.style.display = 'none';
      return true;
    }

    /* MutationObserver: if Okendo re-renders despite hidden container, move again.
       Guarded so resize crossings don't pile up duplicate observers. */
    if (!_starsObserverAttached) {
      _starsObserverAttached = true;
      new MutationObserver(function () { tryMove(); })
        .observe(appBlock, { childList: true, subtree: true });
    }

    if (!tryMove()) {
      var attempts = 0;
      var poll = setInterval(function () {
        if (tryMove() || ++attempts > 40) clearInterval(poll);
      }, 250);
    }
  }

  /* ── Pre-order tooltip: hover popup + bold shipping text ─────────────── */
  function initPreorderDot() {
    var pop = document.querySelector('.wo-pdp-active .shipttct .product__pop');
    if (!pop || pop.dataset.woInit) return;
    if (pop.style.display === 'none' || window.getComputedStyle(pop).display === 'none') return;
    pop.dataset.woInit = '1';
    var tooltip = pop.querySelector('.tooltip');
    if (!tooltip) return;

    /* Hide tooltip immediately to prevent flash */
    tooltip.style.cssText = 'opacity:0;pointer-events:none;position:absolute;';

    /* Bold the ESTIMATED SHIPPING line + add discount urgency from variant metafield */
    var html = tooltip.innerHTML;
    html = html.replace(/(ESTIMATED\s+SHIPPING[^.]*\.)/i, '<strong>$1<\/strong>');
    if (html.toLowerCase().indexOf('pre-order') === -1 && html.toLowerCase().indexOf('demand') === -1 && typeof pre_order_msg === 'object') {
      var msg = '';
      for (var k in pre_order_msg) { if (pre_order_msg[k]) { msg = pre_order_msg[k]; break; } }
      if (msg) {
        html += '<br><strong style="display:block;margin-top:8px;color:#7a3f0f;">' + msg + '</strong>';
      }
    }
    tooltip.innerHTML = html;

    /* Position tooltip in upper-right of product-info on desktop, above on mobile */
    var isMobile = window.innerWidth < 750;
    var w = 240;
    if (!isMobile) {
      /* Anchor to product-info container so it sits in the upper-right blank space */
      var productInfo = pop.closest('.product-info') || pop.closest('[class*="product-info"]');
      if (productInfo) { productInfo.style.position = 'relative'; productInfo.style.overflow = 'visible'; }
      /* Move tooltip out of shipttct and into product-info */
      if (productInfo && tooltip.parentNode) {
        productInfo.appendChild(tooltip);
      }
    } else {
      var shipRow = pop.closest('.shipttct');
      if (shipRow) { shipRow.style.position = 'relative'; shipRow.style.overflow = 'visible'; }
    }
    var pos = isMobile ? 'right:0;bottom:calc(100% + 8px);' : 'top:60px;right:0;';
    var base = 'position:absolute;width:' + w + 'px;padding:12px 14px;padding-right:24px;font-size:10px;font-family:GaisyrMono,monospace;letter-spacing:0.04em;line-height:1.5;border-radius:8px;background:#ffddce;color:#0a0a0a;box-shadow:0 4px 20px rgba(0,0,0,0.1);z-index:100;transition:opacity 0.3s ease;' + pos;

    var show = function () { tooltip.style.cssText = base + 'opacity:1;pointer-events:auto;'; };
    var hide = function () { tooltip.style.cssText = base + 'opacity:0;pointer-events:none;'; };
    hide();

    /* Close button */
    var x = document.createElement('button');
    x.style.cssText = 'position:absolute;top:4px;right:6px;background:none;border:none;font-size:14px;cursor:pointer;color:#333;padding:2px 4px;line-height:1';
    x.type = 'button';
    x.innerHTML = '&times;';
    tooltip.insertBefore(x, tooltip.firstChild);
    var dismissed = false;
    x.onclick = function (e) { e.stopPropagation(); hide(); dismissed = true; };

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (!isTouch) {
      pop.onmouseenter = show;
      pop.onmouseleave = hide;
    } else {
      pop.onclick = function (e) {
        e.preventDefault();
        if (tooltip.style.opacity === '1') { hide(); } else { show(); }
      };
    }

    /* Auto-open when shipping line scrolls into view */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (ent) {
        if (ent[0].isIntersecting && !dismissed) {
          show();
          obs.disconnect();
          setTimeout(function () { if (!dismissed) hide(); }, isTouch ? 8000 : 5000);
        }
      }, { threshold: 0.5 });
      obs.observe(pop);
    }
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    try { initTabs(); } catch (e) { console.warn('wo-pdp: initTabs failed', e); }
    try { initAirlineSearch(); } catch (e) { console.warn('wo-pdp: initAirlineSearch failed', e); }
    try { initThumbGallery(); } catch (e) { console.warn('wo-pdp: initThumbGallery failed', e); }
    try { wrapBundleCards(); } catch (e) { console.warn('wo-pdp: wrapBundleCards failed', e); }
    try { initBundleVariantSync(); } catch (e) { console.warn('wo-pdp: initBundleVariantSync failed', e); }
    try { initStickyCTA(); } catch (e) { console.warn('wo-pdp: initStickyCTA failed', e); }
    try { moveStarsToTagline(); } catch (e) { console.warn('wo-pdp: moveStarsToTagline failed', e); }
    try { initPreorderDot(); } catch (e) { console.warn('wo-pdp: initPreorderDot failed', e); }
    /* Re-try preorder dot on later paints (shipping block may lazy-render) */
    setTimeout(function () { try { initPreorderDot(); } catch (e) {} }, 1000);
    setTimeout(function () { try { initPreorderDot(); } catch (e) {} }, 3000);

    // Drag-to-scroll for pull quotes (desktop)
    var pqScroll = document.querySelector('.wo-pdp-active .wo-pull-quotes');
    if (pqScroll) {
      var isDown = false, startX, scrollLeft;
      pqScroll.addEventListener('mousedown', function (e) {
        isDown = true; pqScroll.classList.add('wo-dragging');
        startX = e.pageX - pqScroll.offsetLeft;
        scrollLeft = pqScroll.scrollLeft;
      });
      pqScroll.addEventListener('mouseleave', function () { isDown = false; pqScroll.classList.remove('wo-dragging'); });
      pqScroll.addEventListener('mouseup', function () { isDown = false; pqScroll.classList.remove('wo-dragging'); });
      pqScroll.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        pqScroll.scrollLeft = scrollLeft - (e.pageX - pqScroll.offsetLeft - startX);
      });
    }

    /* UX: mark unavailable bundle cards */
    document.querySelectorAll('.wo-pdp-active [data-bundle-card]').forEach(function (card) {
      var data = null;
      var el = card.querySelector('.wo-bundle-data');
      if (el) try { data = JSON.parse(el.textContent); } catch (e) {}
      if (!data || !data.items) return;
      var anyAvailable = false;
      for (var i = 0; i < data.items.length; i++) {
        for (var j = 0; j < data.items[i].variants.length; j++) {
          if (data.items[i].variants[j].available) { anyAvailable = true; break; }
        }
        if (anyAvailable) break;
      }
      if (!anyAvailable) {
        card.classList.add('wo-bundle-unavailable');
        var msg = document.createElement('p');
        msg.className = 'wo-bundle-unavailable__msg';
        msg.textContent = 'Currently unavailable';
        card.appendChild(msg);
      }
    });

    // Scroll arrows for bundle + complementary
    var bundleH = document.querySelector('.wo-pdp-active .wo-bundle-offers__heading');
    var bundleR = document.querySelector('.wo-pdp-active .wo-bundle-cards-row');
    if (bundleH && bundleR) injectArrows(bundleH, bundleR);

    var compH = document.querySelector('.wo-pdp-active .complementary-products__header');
    var compR = document.querySelector('.wo-pdp-active .complementary-products__product-list');
    if (compH && compR && !compH.closest('cart-drawer')) injectArrows(compH, compR);

    /* Wire Compare Bags button to the compare drawer */
    var compareBtn = document.querySelector('.wo-pdp-active .wo-compare-btn');
    if (compareBtn) {
      compareBtn.addEventListener('click', function () {
        if (typeof window.woOpenCompareDrawer === 'function') window.woOpenCompareDrawer();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }

  /* ── Bundle ATC — add individual items, skip duplicates ──────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-atc-individual]');
    if (!btn) return;
    var card = btn.closest('[data-bundle-card]');
    if (!card) return;
    var dataEl = card.querySelector('.wo-bundle-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!data.items || !data.items.length) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    /* Determine selected variant ID for each item */
    function getSelectedVariantId(item, itemIdx) {
      /* Check if user picked a swatch */
      var radio = card.querySelector('[data-bundle-item="' + itemIdx + '"] .wo-item-radio:checked');
      var selectedColor = radio ? radio.getAttribute('data-option1') : null;

      /* For the main product, use the PDP's currently selected variant */
      if (item.product_id === data.main_product_id && !selectedColor) {
        var pdpForm = document.querySelector('.wo-pdp-active product-form form, .wo-pdp-active form[id^="product-form"]');
        if (pdpForm) {
          var pdpInput = pdpForm.querySelector('input[name="id"]');
          if (pdpInput) {
            var pdpVid = parseInt(pdpInput.value, 10);
            /* Check if the PDP variant is actually available */
            for (var p = 0; p < item.variants.length; p++) {
              if (item.variants[p].id === pdpVid) {
                if (!item.variants[p].available) {
                  selectedColor = item.variants[p].option1;
                  break; /* fall through to sold-out check below */
                }
                return pdpVid;
              }
            }
          }
        }
      }

      /* Match by color — must be available */
      for (var j = 0; j < item.variants.length; j++) {
        if (selectedColor && item.variants[j].option1 === selectedColor && item.variants[j].available) {
          return item.variants[j].id;
        }
      }
      /* If a color was selected but not available, report it as sold out */
      if (selectedColor) {
        return { soldOut: true, color: selectedColor, title: item.title };
      }
      /* Fallback: first available variant */
      for (var k = 0; k < item.variants.length; k++) {
        if (item.variants[k].available) return item.variants[k].id;
      }
      return null;
    }

    /* Build the list of variant IDs we want to add */
    var wantedItems = [];
    var soldOutItems = [];
    for (var i = 0; i < data.items.length; i++) {
      var vid = getSelectedVariantId(data.items[i], i);
      if (vid && vid.soldOut) {
        soldOutItems.push(vid);
        continue;
      }
      if (vid) wantedItems.push({ id: vid, product_id: data.items[i].product_id });
    }

    /* If any selected variants are sold out, show message instead of adding wrong color */
    if (soldOutItems.length > 0) {
      btn.removeAttribute('aria-busy');
      var names = soldOutItems.map(function (s) { return s.title + ' in ' + s.color; }).join(', ');
      /* Show sold-out message on button */
      btn.classList.add('wo-atc-error');
      var msgEl = document.createElement('span');
      msgEl.className = 'wo-atc-soldout-msg';
      msgEl.textContent = names + ' is sold out — pick another color';
      btn.appendChild(msgEl);
      setTimeout(function () {
        btn.classList.remove('wo-atc-error');
        var msg = btn.querySelector('.wo-atc-soldout-msg');
        if (msg) msg.remove();
        btn.disabled = false;
      }, 4000);
      return;
    }

    /* Collect section IDs the cart drawer needs for re-rendering */
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sectionsToBundle }
    }));
    var sectionsParam = sectionsToBundle.join(',');

    function finishWithDrawer(cartContent, isError) {
      btn.removeAttribute('aria-busy');
      if (isError) {
        /* UX: error state — show message, auto-clear after 3s */
        btn.classList.add('wo-atc-error');
        setTimeout(function () { btn.classList.remove('wo-atc-error'); btn.disabled = false; }, 3000);
        return;
      }
      /* UX: success state — brief confirmation before re-enabling */
      btn.classList.add('wo-atc-success');
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent }
      }));
      setTimeout(function () { btn.classList.remove('wo-atc-success'); btn.disabled = false; }, 1500);
    }

    /* Fetch cart, filter out items already present, add the rest */
    fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartProductIds = {};
        cart.items.forEach(function (li) { cartProductIds[li.product_id] = true; });

        var toAdd = wantedItems.filter(function (w) { return !cartProductIds[w.product_id]; });

        if (toAdd.length === 0) {
          /* Everything already in cart — fetch section HTML then open drawer */
          if (!sectionsParam) { finishWithDrawer(cart); return; }
          return fetch(Shopify.routes.root + '?sections=' + sectionsParam)
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              cart.sections = sections;
              finishWithDrawer(cart);
            });
        }

        var payload = {
          items: toAdd.map(function (w) { return { id: w.id, quantity: 1 }; }),
          sections: sectionsParam
        };

        return fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
        .then(function (resp) {
          if (!resp || !resp.ok) { finishWithDrawer(null, true); return; }
          return resp.json();
        })
        .then(function (addResponse) {
          if (!addResponse) return;
          return fetch(Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              /* Attach section HTML from the add response */
              if (addResponse.sections) cartContent.sections = addResponse.sections;
              finishWithDrawer(cartContent);
            });
        });
      })
      .catch(function () {
        finishWithDrawer(null, true);
      });
  });

  /* "Why" carousel — retry + MutationObserver fallback so we catch
     late-loading multiple-media-with-text sections without waiting 30s. */
  function tryBuild(delay) {
    setTimeout(function() {
      try { buildWhyCarousel(); } catch (e) { console.warn('wo-pdp: buildWhyCarousel failed', e); }
      if (!document.querySelector('.wo-why-carousel') && delay < 3000) {
        tryBuild(delay * 2);
      }
    }, delay);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { tryBuild(500); });
  } else {
    tryBuild(500);
  }

  /* MutationObserver fallback — fires the moment the multi-media sections
     populate. Solves the "carousel appears 30s late" problem on slow
     connections where the static retries (0/500/1500/3000ms) miss the window. */
  if (window.MutationObserver) {
    var whyBuiltViaObserver = false;
    var mo = new MutationObserver(function () {
      if (whyBuiltViaObserver) return;
      if (document.querySelectorAll('.wo-pdp-active .shopify-section--multiple-media-with-text').length >= 2) {
        whyBuiltViaObserver = true;
        try { buildWhyCarousel(); } catch (e) {}
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // Stop watching after 60s so we don't run forever
    setTimeout(function () { mo.disconnect(); }, 60000);
  }

  /* Resize-aware rebuild: when the viewport crosses the 1200px breakpoint,
     rip out the existing carousel and rebuild for the new size, AND re-move
     the buy-box stars into the tagline row. Without this, stretching a small
     window past 1200 (or vice versa) leaves the wrong carousel in place —
     CSS hides whichever doesn't match, so the section appears to vanish.
     Same goes for the desktop tagline-row stars: if the page loaded at
     mobile, moveStarsToTagline returned early; we need to run it again
     once the viewport is wide enough. */
  var pdpResizeTimer = null;
  var lastIsDesktop = window.innerWidth >= 1200;
  window.addEventListener('resize', function () {
    var nowIsDesktop = window.innerWidth >= 1200;
    if (nowIsDesktop === lastIsDesktop) return;
    lastIsDesktop = nowIsDesktop;
    clearTimeout(pdpResizeTimer);
    pdpResizeTimer = setTimeout(function () {
      try { buildWhyCarousel(); } catch (e) { console.warn('wo-pdp: resize rebuild failed', e); }
      try { moveStarsToTagline(); } catch (e) { console.warn('wo-pdp: resize move stars failed', e); }
    }, 150);
  });
})();

/* ════════════════════════════════════════════════════════════════════════════
   PDP REDESIGN — ATC checkmark + review-count anchor (round 3)
   ════════════════════════════════════════════════════════════════════════════ */
(function () {
  if (!document.body.classList.contains('wo-pdp-active')) return;

  /* ── ATC: show "✓ Added to Cart" briefly after a successful add ──────── */
  function getMainAtc() {
    return document.querySelector('.wo-pdp-active .product-info buy-buttons button[type="submit"]');
  }
  function flashAdded(btn) {
    if (!btn || btn.dataset.woAddedAnimating === '1') return;
    btn.dataset.woAddedAnimating = '1';
    var labelEl = btn.querySelector('.wo-atc-label-original') || (function () {
      // Wrap original text so we can swap visibility
      var span = document.createElement('span');
      span.className = 'wo-atc-label-original';
      // Move all child text/elements into the wrapper
      while (btn.firstChild) span.appendChild(btn.firstChild);
      btn.appendChild(span);
      return span;
    })();
    var checkEl = btn.querySelector('.wo-atc-check-mark') || (function () {
      var span = document.createElement('span');
      span.className = 'wo-atc-check-mark';
      span.style.cssText = 'display:inline-flex;align-items:center;gap:8px;';
      span.innerHTML = '✓ Added to Cart';
      btn.appendChild(span);
      return span;
    })();
    labelEl.style.display = 'none';
    checkEl.style.display = 'inline-flex';
    btn.classList.add('wo-atc-added');
    setTimeout(function () {
      btn.classList.remove('wo-atc-added');
      labelEl.style.display = '';
      checkEl.style.display = 'none';
      btn.dataset.woAddedAnimating = '';
    }, 2200);
  }
  document.documentElement.addEventListener('cart:change', function (e) {
    var d = e && e.detail;
    if (!d) return;
    var added = d.baseEvent === 'variant:add' || d.baseEvent === 'cart:add';
    if (!added) return;
    flashAdded(getMainAtc());
  });
  // Fallback: if cart:change isn't dispatched, listen for the form submit completing
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    setTimeout(function () { flashAdded(getMainAtc()); }, 600);
  }, true);

  /* ── Pull-quote scroll arrows ─────────────────────────────────────── */
  function initPullQuoteArrows() {
    document.querySelectorAll('.wo-pdp-active .wo-pull-quotes').forEach(function (rail) {
      // Find the nearest header (sibling above .wo-pull-quotes-wrap) that holds the arrows
      var wrap = rail.closest('.wo-pull-quotes-wrap');
      var container = wrap ? wrap.parentNode : rail.parentNode;
      var header = container ? container.querySelector('.wo-pull-quotes-header') : null;
      var prev = header ? header.querySelector('.wo-pq-nav--prev') : null;
      var next = header ? header.querySelector('.wo-pq-nav--next') : null;
      if (!prev || !next) return;
      if (prev.dataset.woWired === '1') return; // avoid rebinding
      prev.dataset.woWired = '1';
      next.dataset.woWired = '1';
      function step() { return Math.max(220, rail.clientWidth * 0.7); }
      function update() {
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        prev.classList.toggle('is-disabled', atStart);
        next.classList.toggle('is-disabled', atEnd);
      }
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function (e) {
        e.preventDefault();
        rail.scrollBy({ left:  step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPullQuoteArrows);
  } else {
    initPullQuoteArrows();
  }

  /* ── Review count → scroll to Okendo reviews widget (CAPTURE-phase) ──
     Capture-phase click listener so we win against Okendo's own handlers.
     Matches any okendo-flavored element inside the buy-box area. */
  function getReviewTarget() {
    return document.querySelector('.wo-pdp-active .shopify-section--apps')
        || document.querySelector('.wo-pdp-active [id^="shopify-section-1728056287229ffa50"]')
        || document.querySelector('.wo-pdp-active .oke-w-reviews');
  }
  function isInProductInfoStars(el) {
    if (!el || !el.closest) return false;
    var info = el.closest('.wo-pdp-active .product-info');
    if (!info) return false;
    return !!(
      el.closest('[data-block-type*="okendo"]') ||
      el.closest('[data-block-type*="star-rating"]') ||
      el.closest('[data-block-type="okendo_star_rating"]') ||
      el.closest('[class*="oke-stars"]') ||
      el.closest('[class*="oke-w-rating"]') ||
      el.closest('[class*="oke-star"]') ||
      el.closest('a[data-oke-rating-link]') ||
      el.closest('.oke-stars-link') ||
      el.closest('a[href*="#reviews"]') ||
      el.closest('a[href*="reviews"]')
    );
  }
  function scrollToReviews(e) {
    if (!isInProductInfoStars(e.target)) return;
    var target = getReviewTarget();
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', scrollToReviews, true);
  document.addEventListener('mousedown', scrollToReviews, true);
  document.addEventListener('pointerdown', scrollToReviews, true);

  // Direct-bind on the okendo star block AND on any link inside it.
  // Poll/observe because Okendo lazy-renders.
  function bindReviewCountDirect() {
    var blocks = document.querySelectorAll(
      '.wo-pdp-active .product-info .product-info__block-item[data-block-type^="shopify://apps/okendo/blocks/star-rating"], ' +
      '.wo-pdp-active .product-info .product-info__block-item[data-block-type="okendo_star_rating"]'
    );
    blocks.forEach(function (block) {
      if (block.dataset.woReviewWired !== '1') {
        block.dataset.woReviewWired = '1';
        block.addEventListener('click', scrollToReviews, true);
      }
      // Also catch any anchor or button rendered by Okendo inside the block
      block.querySelectorAll('a, button, [role="button"], [class*="count"], [class*="Count"], [class*="link"], [class*="Link"]').forEach(function (el) {
        if (el.dataset.woReviewWired === '1') return;
        el.dataset.woReviewWired = '1';
        el.addEventListener('click', function (e) {
          var target = getReviewTarget();
          if (!target) return;
          e.preventDefault();
          e.stopPropagation();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, true);
        // Make sure they look clickable
        el.style.cursor = 'pointer';
      });
    });
  }

  /* (Okendo star block shrinkage removed — was unreliable.) */

  // Style the star block as clickable (poll + observe — Okendo loads async)
  function styleStarBlock() {
    var blocks = document.querySelectorAll(
      '.wo-pdp-active .product-info .product-info__block-item[data-block-type^="shopify://apps/okendo/blocks/star-rating"], ' +
      '.wo-pdp-active .product-info .product-info__block-item[data-block-type="okendo_star_rating"], ' +
      '.wo-pdp-active .product-info [class*="oke-w-rating"], ' +
      '.wo-pdp-active .product-info [class*="oke-stars"]'
    );
    blocks.forEach(function (b) { b.style.cursor = 'pointer'; });
    bindReviewCountDirect();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleStarBlock);
  } else {
    styleStarBlock();
  }
  [500, 1500, 3000].forEach(function (t) { setTimeout(styleStarBlock, t); });
  var infoEl = document.querySelector('.wo-pdp-active .product-info');
  if (infoEl && window.MutationObserver) {
    new MutationObserver(styleStarBlock).observe(infoEl, { childList: true, subtree: true });
  }
  /* ── Q&A horizontal rail: arrows + edge fade wrapper ─────────────── */
  function initQARail() {
    var list = document.querySelector('.wo-pdp-active .shopify-section--apps .oke-qw-questionList');
    if (!list || list.dataset.woQaWired === '1') return false;

    // Wrap the list so we can position absolute arrows + fade against it
    var wrap = list.parentNode;
    if (!wrap) return false;
    if (!wrap.classList.contains('wo-qw-rail-wrap')) {
      var newWrap = document.createElement('div');
      newWrap.className = 'wo-qw-rail-wrap';
      list.parentNode.insertBefore(newWrap, list);
      newWrap.appendChild(list);
      wrap = newWrap;
    }

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'wo-qw-arrow wo-qw-arrow--left';
    prev.setAttribute('aria-label', 'Previous question');
    prev.innerHTML = '‹';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'wo-qw-arrow wo-qw-arrow--right';
    next.setAttribute('aria-label', 'Next question');
    next.innerHTML = '›';

    wrap.appendChild(prev);
    wrap.appendChild(next);
    list.dataset.woQaWired = '1';

    function step() {
      var card = list.querySelector('.oke-qw-questionList-item');
      if (card) return card.getBoundingClientRect().width + 16;
      return Math.max(280, list.clientWidth * 0.7);
    }
    var qaLoading = false;
    function loadMoreQA() {
      if (qaLoading) return;
      var btn = document.querySelector('.shopify-section--apps .oke-showMore-button');
      if (!btn) return;
      qaLoading = true;
      var prevCount = list.querySelectorAll('.oke-qw-questionList-item').length;
      btn.click();
      var ticks = 0;
      var poll = setInterval(function () {
        ticks++;
        var now = list.querySelectorAll('.oke-qw-questionList-item').length;
        if (now > prevCount || ticks > 30) {
          clearInterval(poll);
          qaLoading = false;
          update();
        }
      }, 300);
    }
    function update() {
      prev.disabled = list.scrollLeft <= 4;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
      var hasMore = !!document.querySelector('.shopify-section--apps .oke-showMore-button');
      next.disabled = atEnd && !hasMore;
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); list.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 10;
      if (atEnd) { loadMoreQA(); }
      else { list.scrollBy({ left: step(), behavior: 'smooth' }); }
    });
    list.addEventListener('scroll', function () {
      update();
      var nearEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 200;
      if (nearEnd) loadMoreQA();
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
    return true;
  }
  /* ── Per-card expand: clamp long Q&A + Review text, toggle reveal ────── */
  function getCardBodies(card) {
    return card.querySelectorAll(
      '.oke-qw-question-main-body, .oke-qw-answer-main-body, ' +
      '[class*="qw-answer"] [class*="body"], ' +
      '.oke-reviewContent-body, [class*="reviewContent-body"], .oke-reviewContent-body p'
    );
  }
  function cardWouldOverflow(card) {
    // Measure with the clamp temporarily off — gives us the natural full
    // height. Compare against the clamp's max-height (4 lines × 1.55em ≈ 6.2em).
    if (!card.offsetParent) return false; // hidden parent → can't measure
    var bodies = getCardBodies(card);
    var threshold;
    for (var i = 0; i < bodies.length; i++) {
      var el = bodies[i];
      var fontSize = parseFloat(getComputedStyle(el).fontSize) || 14;
      threshold = fontSize * 1.55 * 4 + 2;
      // Strip our clamp by measuring outside the .wo-qa-clampable rule
      // (we add the class only after we know we need it)
      if (el.scrollHeight > threshold) return true;
    }
    return false;
  }
  function syncExpandVisibility(card) {
    var toggle = card.querySelector(':scope > .wo-qa-expand');
    if (!toggle) return;
    // If currently open: keep toggle visible (acts as collapse)
    if (card.classList.contains('wo-qa-open')) { toggle.style.display = ''; return; }
    // If parent is hidden (inactive tab), don't change clampable state
    if (!card.offsetParent) { return; }
    // Only measure once per card; subsequent observer fires shouldn't keep
    // re-toggling the clamp class (was causing cards to "collapse again").
    if (card.dataset.woQaSynced === '1') return;
    var needsClamp = cardWouldOverflow(card);
    card.classList.toggle('wo-qa-clampable', needsClamp);
    toggle.style.display = needsClamp ? '' : 'none';
    card.dataset.woQaSynced = '1';
  }
  function attachExpand(card) {
    if (!card || card.dataset.woQaExpand === '1') return;
    card.dataset.woQaExpand = '1';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'wo-qa-expand';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Expand');
    toggle.style.display = 'none'; // start hidden, reveal only if overflow
    toggle.innerHTML = '<span class="wo-qa-expand__chev" aria-hidden="true">▾</span>';
    card.appendChild(toggle);
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = card.classList.toggle('wo-qa-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    // Defer the overflow check so layout settles
    requestAnimationFrame(function () { syncExpandVisibility(card); });
  }
  function syncAllExpandVisibility() {
    document.querySelectorAll('.wo-pdp-active .shopify-section--apps .oke-qw-questionList-item, .wo-pdp-active .shopify-section--apps .oke-w-review').forEach(syncExpandVisibility);
  }
  window.addEventListener('resize', function () {
    clearTimeout(syncAllExpandVisibility._t);
    syncAllExpandVisibility._t = setTimeout(syncAllExpandVisibility, 120);
  });
  function initQAExpand() {
    document.querySelectorAll('.wo-pdp-active .shopify-section--apps .oke-qw-questionList-item').forEach(function (c) {
      attachExpand(c); syncExpandVisibility(c);
    });
  }
  function initReviewExpand() {
    document.querySelectorAll('.wo-pdp-active .shopify-section--apps .oke-w-review').forEach(function (c) {
      attachExpand(c); syncExpandVisibility(c);
    });
  }

  /* ── Okendo Q&A loads async + recreates DOM on tab switches ──────────── */
  /* ── Kill empty scroll-gap below the questions list ──────────────────
     Walks up from .oke-qw-questionList collapsing every container above
     it that has extra height beyond its content (footer, pagination,
     show-more wrapper, etc.). */
  function collapseQATailGap() {
    var list = document.querySelector('.wo-pdp-active .shopify-section--apps .oke-qw-questionList');
    if (!list) return;
    // Walk up to apps section; collapse every NEXT sibling at each level
    var node = list.closest('.wo-qw-rail-wrap') || list;
    var apps = document.querySelector('.wo-pdp-active .shopify-section--apps');
    while (node && node !== apps && node !== document.body) {
      var sib = node.nextElementSibling;
      while (sib) {
        // Don't blow away tab nav, headings, or anything visible & meaningful
        var hasText = (sib.textContent || '').trim().length > 0;
        var isNav = sib.matches && sib.matches('[class*="navBar"], [class*="tab"], [class*="sortSelect"], [class*="filter"], [class*="header"]');
        if (!hasText && !isNav) {
          sib.style.cssText = 'display:none !important; height:0 !important; min-height:0 !important; margin:0 !important; padding:0 !important;';
        } else if (sib.matches && sib.matches('[class*="footer"], [class*="showMore"], [class*="loadMore"], [class*="pagination"]')) {
          sib.style.cssText = 'min-height:0 !important; height:auto !important; padding:0 !important; margin:0 !important;';
        }
        sib = sib.nextElementSibling;
      }
      node = node.parentElement;
    }
  }

  /* ── Force Okendo widget chrome to height: auto via inline !important ── */
  function nukeOkendoHeights() {
    var sels = [
      '.wo-pdp-active .shopify-section--apps .okeReviews',
      '.wo-pdp-active .shopify-section--apps [data-oke-container]',
      '.wo-pdp-active .shopify-section--apps .js-oke-widgetSize',
      '.wo-pdp-active .shopify-section--apps .oke-is-small',
      '.wo-pdp-active .shopify-section--apps .oke-is-medium',
      '.wo-pdp-active .shopify-section--apps .oke-is-large',
      '.wo-pdp-active .shopify-section--apps .oke-w',
      '.wo-pdp-active .shopify-section--apps .oke-w-main',
      '.wo-pdp-active .shopify-section--apps .oke-w-panel',
      '.wo-pdp-active .shopify-section--apps .oke-w-questionsTab',
      '.wo-pdp-active .shopify-section--apps .oke-w-reviewsTab',
      '.wo-pdp-active .shopify-section--apps .oke-questions',
      '.wo-pdp-active .shopify-section--apps .oke-questions-main',
      '.wo-pdp-active .shopify-section--apps .oke-questions-main-alerts',
      '.wo-pdp-active .shopify-section--apps .oke-questions-footer',
      '.wo-pdp-active .shopify-section--apps .oke-qw-header',
      '.wo-pdp-active .shopify-section--apps [class*="questions-panel"]',
      '.wo-pdp-active .shopify-section--apps [class*="reviews-panel"]'
    ];
    document.querySelectorAll(sels.join(',')).forEach(function (el) {
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', 'none', 'important');
    });
    // Reconcile each panel's visibility on every pass — clear our inline
    // display:none when Okendo flips a panel back to active.
    document.querySelectorAll('.wo-pdp-active .shopify-section--apps .oke-w-panel').forEach(function (panel) {
      var isHidden = panel.getAttribute('aria-hidden') === 'true' || panel.hasAttribute('hidden');
      if (isHidden) {
        panel.style.setProperty('display', 'none', 'important');
      } else {
        panel.style.removeProperty('display');
      }
    });
  }

  function tryInitQARailDeep() {
    initQARail();
    initQAExpand();
    initReviewExpand();
    collapseQATailGap();
    nukeOkendoHeights();
  }
  [400, 1000, 2000, 4000].forEach(function (t) { setTimeout(tryInitQARailDeep, t); });
  (function watchAppsSection(retry) {
    var apps = document.querySelector('.wo-pdp-active .shopify-section--apps');
    if (!apps) {
      if ((retry || 0) < 30) setTimeout(function () { watchAppsSection((retry || 0) + 1); }, 600);
      return;
    }
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        // setProperty is a no-op when the value matches, so re-runs from our
        // own style writes don't cause infinite recursion. Just debounce.
        clearTimeout(t);
        t = setTimeout(tryInitQARailDeep, 60);
      }).observe(apps, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-hidden', 'hidden']
      });
    }
    // Belt-and-braces: also re-nuke heights on a fast interval so any late
    // resize Okendo schedules can't reintroduce the gap.
    setInterval(nukeOkendoHeights, 500);
  })(0);
})();
